import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';

// Icons
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';


// Components
import { Drawer } from './Drawer';
import PageNavigation from 'pages/LocationLayout/PageNavigation';
import { Grid } from '@mui/material';

/**
 * Component for the left navigation bar with a collapsible drawer.
 *
 * @returns {JSX.Element} The rendered component.
 */
export default function LeftNavigationBar() {
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  /**
   * Function to open the drawer.
   */
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  /**
   * Function to close the drawer.
   */
  const handleDrawerClose = () => {
    setOpen(false);
  };
  

  return (
    <Drawer variant="permanent" open={open} data-testid="drawer"
      sx={{
        '& .MuiDrawer-paper': {
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
        <PageNavigation open={open}/>
       <Grid style={{bottom:'0px', position:'fixed',display:'flex', alignSelf:'self-end'}}>
      <Divider />
      <IconButton
        color="primary"
        data-testid="menu-icon-button"
        onClick={open ? handleDrawerClose : handleDrawerOpen}
        sx={{ margin: "10px", alignSelf: "flex-end" }}
      >
        {(() => {
          if (open) {
            return theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />;
          }
          return <MenuIcon />;
        })()}
      </IconButton>
      </Grid>
    </Drawer>
  );
}
